export const DAYS_FETCH_REQUEST='days-fetch-request';
export const DAYS_FETCH_SUCCESS='days-fetch-success';
export const DAYS_FETCH_FAILURE='days-fetch-failure';